var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Escala Customer")]),_c('p',[_vm._v(" Customer ID: "),_c('strong',[_vm._v(_vm._s(_vm.customerId))])]),_c('button',{staticClass:"btn btn-info-button",on:{"click":_vm.sendCustomerToEscala}},[_vm._v(" Send customer to escala ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }